import "./JourneyHome.module.css";
import KennelEliteHeader from "@/reusable_sections/Header";
import PathToEnrollment from "./sections/PathToEnrollment";
import LogisticsFaq from "./sections/LogisticsFaq";
import ShowCalendar from "./sections/ShowCalendar";
import ShowSchedule from "./sections/ShowSchedule";
import PartnerNetwork from "./sections/PartnerNetwork";
import AtlasRootsFooter from "@/reusable_sections/Footer";
export default function JourneyHomePage() {
  return <div>
      <KennelEliteHeader />
      <PathToEnrollment />
      <LogisticsFaq />
      <ShowCalendar />
      <ShowSchedule />
      <PartnerNetwork />
      <AtlasRootsFooter />
    </div>;
}